export const enum BannerTheme {
  DASHBOARD = 'dashboard',
  REWARDS_LANDING = 'rewards-landing',
}
